<template>
  <div class="lp-create__review">
    <div class="lp-create__review__inner">
      <div class="lp-create__copy">
        <h2 class="lp-create__copy__title">
          お客様の声
        </h2>
      </div>

      <BaseSlider
        :items="items"
        track-class="lp-create__review__track"
        slide-class="lp-create__review__slide"
      >
        <template #item="{ item }">
          <div class="lp-create__review__item">
            <div class="lp-create__review__item__info">
              <div class="lp-create__review__item__info__header">
                <div class="lp-create__review__item__image">
                  <img
                    v-if="item.gender == 1"
                    :src="maleImage"
                    alt="男性"
                    width="48"
                    height="48"
                  >
                  <img
                    v-else
                    :src="femaleImage"
                    alt="女性"
                    width="48"
                    height="48"
                  >
                </div>

                <div>
                  <p class="lp-create__review__item__province">
                    {{ provinceMap[item.province_id] }}
                  </p>

                  <p class="lp-create__review__item__job">
                    {{ item.businessType }}
                  </p>
                </div>
              </div>
            </div>

            <p
              class="lp-create__review__item__content"
              v-html="$nl2br(item.content)"
            />
          </div>
        </template>
      </BaseSlider>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cloudfrontMixin from '@/mixins/cloudfrontMixin';
import BaseSlider from '@/components/frontend/Landing/BaseSlider';

export default {
  components: {
    BaseSlider
  },
  mixins: [cloudfrontMixin],
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  async beforeMount() {
    await this.$store.dispatch('particles/province/getList');
  },
  computed: {
    ...mapState({
      provinces: state => state.particles.province.list,
    }),
    provinceMap() {
      return this.provinces.reduce((map, province) => {
        map[province.id] = province.name;
        return map;
      }, {});
    },
    maleImage() {
      return this.getFileWithCDN('/img/landing/voice_male.png');
    },
    femaleImage() {
      return this.getFileWithCDN('/img/landing/voice_female.png');
    }
  }
};
</script>
<style lang="scss" scoped>
.lp-create__review {
  &__inner {
    width: 90%;
    max-width: 1180px;
    padding: 80px 0;
    margin: 0 auto;
    display: block;
  }
  &__content {
    background: #fff;
    padding: 32px 15px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media screen and (min-width: 768px), print {
      padding: 40px;
    }
  }
  &__item {
    border-radius: 10px;
    background: #fafafa;
    padding: 24px;
    box-shadow: 0 3px 1px -3px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    height: 100%;
    min-height: 320px;
    &__title {
      color: #565f74;
      font-size: 1.6rem;
      line-height: 1.5;
      margin-bottom: 10px;
    }
    &__info {
      font-size: 1.6rem;
      line-height: 1.5;
      margin-bottom: 10px;
      &__header {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;
      }
    }
    &__content {
      color: #222;
      font-size: 1.6rem;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      padding: 0 8px;
    }
    &__image {
      flex-shrink: 0;
      width: 48px;
      height: 48px;
    }
    &__province {
      color: #888;
      font-size: 1.4rem;
      font-style: normal;
      font-weight: 400;
      line-height: 100%;
      margin-bottom: 4px;
    }
    &__job {
      color: #222;
      font-size: 1.6rem;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
    }
  }
  @media screen and (min-width: 768px), print {
    &::v-deep {
      .lp-create__review__track {
        display: grid;
        grid-template-columns: 1fr;
        gap: 40px;
        margin: 0;
        padding: 0;
        flex: 1;
      }
    }
    &__item {
      box-shadow: none;
    }
  }
  @media screen and (min-width: 960px), print {
    &::v-deep {
      .lp-create__review__track {
        grid-template-columns: 1fr 1fr;
      }
    }
  }
}
</style>
